import { render } from "./GradesListView.vue?vue&type=template&id=78a4b278&scoped=true"
import script from "./GradesListView.vue?vue&type=script&lang=js"
export * from "./GradesListView.vue?vue&type=script&lang=js"

import "./GradesListView.vue?vue&type=style&index=0&id=78a4b278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a4b278"]])

export default __exports__